import React from 'react';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import { Avatar, Button, Divider, Grid } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import { ReactComponent as TrashAltSolid } from '../../module/chestionare/Icoane Font Awesome/trash-alt-solid.svg'
import { ReactComponent as PenSolid } from '../../module/chestionare/Icoane Font Awesome/pen-solid.svg'
import Masks from '../../providers/Masks';

import picWord from '../../Pics/picWord.png'
import picPdf from '../../Pics/picPdf.png'
import picJpg from '../../Pics/picJpg.png'




export default class RaportPersonalSubItem extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            readOnly: true,
            dataStart: this.u.defaultData(),
            concediuMedical: 0,
            concediuOdihna: 0,
            concediuZileSpeciale: 0,
            alteConcedii: 0,
            zileConcediu: 0,
            docs: []
        }
    }

    componentDidMount() {
        this.getConcedii()

        this.getDocumenteAngajat()
    }

    u = new Utils();
    ws = new Ws()
    m = new Masks()


    getDocumenteAngajat = async () => {

        console.log('this.props.angajat.id :>> ', this.props.angajat.id);

        let getDocumente = await this.ws.customSelect('select * from angajati_documente where id_angajat = @p1', {
            p1: this.props.angajat.id
        })


        console.log('getDocumente :>> ', getDocumente);


        if (getDocumente.Succes) {

            let docs = [...getDocumente.Content]

            let newDocs = []

            let docsLength = docs.length


            console.log('docs :>> ', docs);

            this.setState({ docs: docs })

            console.log('newDocs :>> ', newDocs);

        }

    }


    getConcedii = async () => {
        console.log('this.props.angajat.id :>> ', this.props.angajat.id);

        let conc = await this.ws.customSelect(`select c.*, p.id_angajat from concedii c left outer join pontaje p on p.id_concediu = c.id
        where (year(c.cand_inceput_data) = year(@p1) OR year(c.cand_sfarsit_data) = year(@p1)) and isnull(p.sters,0) != 1 and p.id_angajat = @p2 ` , {
            p1: this.state.dataStart,
            p2: this.props.angajat.id
        })


        if (conc.Succes) {



            let concedii = [...conc.Content]
            let concediuMedical = 0
            let concediuOdihna = 0
            let concediuZileSpeciale = 0

            let alteConcedii = 0


            for (let i = 0, n = concedii.length; i < n; i++) {

                let dayDiff = this.u.getDaysDifference(concedii[i].cand_inceput_data, concedii[i].cand_sfarsit_data)

                if (concedii[i].tip_concediu === 'concediu_medical') {


                    concediuMedical += dayDiff
                } else if (concedii[i].tip_concediu === 'concediu_odihna') {
                    concediuOdihna += dayDiff

                } else if (concedii[i].tip_concediu === 'evenimente_speciale') {
                    concediuZileSpeciale += dayDiff
                } else {
                    alteConcedii += dayDiff
                }


            }


            let zileConcediu = (this.props.angajat.nr_zile_concediu || 21) - concediuOdihna

            this.setState({
                concediuMedical: concediuMedical,
                concediuOdihna: concediuOdihna,
                concediuZileSpeciale: concediuZileSpeciale,
                alteConcedii: alteConcedii,
                zileConcediu: zileConcediu
            })
        }
    }




    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }


    uploadPoza = async (id, idAngajat, bkId) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        let chPoza = document.getElementById(bkId)




        reader.onload = async () => {
            let fileContent = reader.result;
            chPoza.style.backgroundImage = ` url(${fileContent})`
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

            // let uploadDocument = await ws.uploadimage('Upload/DocumentAngajat', saveFile, idAngajat);

            // console.log('uploadDocument :>> ', uploadDocument);

            console.log('uploadImage :', uploadImage);
            // if (uploadImage.Succes) {




            // }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }


    goToDoc = (doc) => {
        window.open(`${new Ws().adresaMedia}/Angajati/${doc.token}`)

    }



    uploadDocument = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        // let chPoza = document.getElementById(bkId)




        reader.onload = async () => {
            let fileContent = reader.result;

            // console.log(fileContent);
            // console.log('saveFile :', saveFile);




            let uploadDocument = await ws.uploadimage('Upload/DocumentAngajat', saveFile, idAngajat);

            console.log('uploadDocument :>> ', uploadDocument);

            // console.log('uploadImage :', uploadImage);
            if (uploadDocument.Succes) {

                this.getDocumenteAngajat()


            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    deleteUser = async (us) => {

        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: this.props.angajat.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: this.props.angajat.id, id_departament: this.props.angajat.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: this.props.angajat.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { id_user_bazadate_proprie: this.props.angajat.id_user })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {



            this.props.history.goBack()


        }
    }


    render() {
        return (
            <Grid container>


                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <input type='file' id={`file${this.props.angajat.id}`}
                                style={{ display: 'none' }}
                                accept='image/*'
                                onChange={() => { this.uploadPoza(`file${this.props.angajat.id}`, this.props.angajat.id, 'angajat-upload-poza') }} />

                            <div
                                id={'angajat-upload-poza'}
                                onClick={() => { this.selectFile(`file${this.props.angajat.id}`) }}
                                className='pm-angajati-picture-update'
                                style={{
                                    backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`,
                                    position: 'relative',
                                    left: 0,
                                    top: 0
                                }}>

                                <i style={{
                                    backgroundColor: 'white',
                                    padding: 5,
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    bottom: 5,
                                    right: 0
                                }} className="material-icons">photo_camera</i>

                            </div>


                            <h3 className='pm-angajat-titlu'>{this.props.angajat.nume}</h3>
                            <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.props.angajat.functie} - {this.props.angajat.nume_departament}</span>

                      
                        </Grid>







                    </Grid>

                  
                </Grid>






                <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>

                    <Grid container>
                   


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>
                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginTop: 10 }} > {this.dictionary.pontaje.balantaConcediu}</h5>
                                </Grid>


                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100%'
                                }}>
                                    <div style={{ textAlign: 'center', marginRight: 20 }}>
                                        <div style={{
                                            height: 80,
                                            width: 80,
                                            border: '2px solid rgb(75, 146, 232)',
                                            margin: 'auto',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            color: 'rgb(75, 146, 232)'
                                        }}>
                                            <div style={{ fontSize: 12 }}>
                                                <span style={{ display: 'block' }}>{this.state.concediuOdihna}</span>
                                                <span>{this.dictionary.pontaje.zile}</span>

                                            </div>


                                        </div>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.concediu}</span>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.odihna}</span>
                                    </div>

                                    <div style={{ textAlign: 'center', marginRight: 20 }}>
                                        <div style={{
                                            height: 80,
                                            width: 80,
                                            border: '2px solid rgb(252 99 7)',
                                            margin: 'auto',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            color: 'rgb(252	99	7)'
                                        }}>
                                            <div style={{ fontSize: 12 }}>
                                                <span style={{ display: 'block' }}>{this.state.concediuMedical}</span>
                                                <span>{this.dictionary.pontaje.zile}</span>

                                            </div>


                                        </div>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.concediu}</span>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.medical}</span>
                                    </div>

                                    <div style={{ textAlign: 'center', marginRight: 20 }}>
                                        <div style={{
                                            height: 80,
                                            width: 80,
                                            border: '2px solid rgb(254	206	52)',
                                            margin: 'auto',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            color: 'rgb(254	206	52)'
                                        }}>
                                            <div style={{ fontSize: 12 }}>
                                                <span style={{ display: 'block' }}>{this.state.concediuZileSpeciale}</span>
                                                <span>{this.dictionary.pontaje.zile}</span>

                                            </div>


                                        </div>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.concediu}</span>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.zileSpeciale}</span>
                                    </div>

                                    <div style={{ textAlign: 'center', marginRight: 20 }}>
                                        <div style={{
                                            height: 80,
                                            width: 80,
                                            border: '2px solid rgb(240 240 240)',
                                            margin: 'auto',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            color: 'rgb(117	116	117)'
                                        }}>
                                            <div style={{ fontSize: 12 }}>
                                                <span style={{ display: 'block' }}>{this.state.alteConcedii}</span>
                                                <span>{this.dictionary.pontaje.zile}</span>

                                            </div>


                                        </div>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.alteConcedii}</span>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.concediu}</span>
                                    </div>

                                    <div style={{ textAlign: 'center', marginRight: 20 }}>
                                        <div style={{
                                            height: 80,
                                            width: 80,
                                            border: '2px solid rgb(41 204 88)',
                                            margin: 'auto',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            color: 'rgb(41 204 88)'
                                        }}>
                                            <div style={{ fontSize: 12 }}>
                                                <span style={{ display: 'block' }}>{this.state.zileConcediu}</span>
                                                <span>{this.dictionary.pontaje.zile}</span>

                                            </div>


                                        </div>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.zileConcediu}</span>
                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.ramase}</span>
                                    </div>

                                </div>



                            </Grid>

                        </Grid>


                        {(this.props.ultimaEvaluareManager || this.props.ultimaEvaluareAngajati || this.props.ultimaEvaluareClienti) &&

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginTop: 10 }} > {this.dictionary.pontaje.evaluari}</h5>
                                    </Grid>

                                    {this.props.ultimaEvaluareManager &&

                                        <Grid style={{
                                            textAlign: 'left',
                                            backgroundColor: 'rgb(250 250 250)',
                                            padding: 10,
                                            margin: 'auto'
                                        }} item xs={11} sm={11} md={11} lg={11} xl={11}>
                                            <Grid container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareManager.nume}</span>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Grid container>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.data}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(this.props.ultimaEvaluareManager.cand_creat)}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.evaluatori}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareManager.completari_toate}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.completare}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareManager.procent_completare}%</span>


                                                        </Grid>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.punctaj}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: this.props.ultimaEvaluareManager.color_puncte }}>{this.props.ultimaEvaluareManager.puncte}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'right', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                            <i style={{ cursor: 'pointer', color: 'rgb(100	100	100)' }} className='material-icons'>assessment</i>


                                                        </Grid>


                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    }



                                    {this.props.ultimaEvaluareAngajati &&
                                        <Grid style={{
                                            textAlign: 'left',
                                            backgroundColor: 'rgb(250 250 250)',
                                            padding: 10,
                                            margin: 'auto',
                                            marginTop: 10
                                        }} item xs={11} sm={11} md={11} lg={11} xl={11}>
                                            <Grid container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareAngajati.nume}</span>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Grid container>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.data}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(this.props.ultimaEvaluareAngajati.cand_creat)}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.evaluatori}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareAngajati.completari_toate}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.completare}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareAngajati.procent_completare}%</span>


                                                        </Grid>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.punctaj}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: this.props.ultimaEvaluareAngajati.color_puncte }}>{this.props.ultimaEvaluareAngajati.puncte}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'right', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                            <i style={{ cursor: 'pointer', color: 'rgb(100	100	100)' }} className='material-icons'>assessment</i>


                                                        </Grid>


                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    }


                                    {this.props.ultimaEvaluareClienti &&
                                        <Grid style={{
                                            textAlign: 'left',
                                            backgroundColor: 'rgb(250 250 250)',
                                            padding: 10,
                                            margin: 'auto',
                                            marginTop: 10
                                        }} item xs={11} sm={11} md={11} lg={11} xl={11}>
                                            <Grid container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareClienti.nume}</span>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Grid container>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.data}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(this.props.ultimaEvaluareClienti.cand_creat)}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.evaluatori}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareClienti.completari_toate}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.completare}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.ultimaEvaluareClienti.procent_completare}%</span>


                                                        </Grid>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.punctaj}</span>
                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: this.props.ultimaEvaluareClienti.color_puncte }}>{this.props.ultimaEvaluareClienti.puncte}</span>


                                                        </Grid>

                                                        <Grid style={{ textAlign: 'right', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                            <i style={{ cursor: 'pointer', color: 'rgb(100	100	100)' }} className='material-icons'>assessment</i>


                                                        </Grid>


                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    }




                                </Grid>
                            </Grid>
                        }


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>
                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginTop: 10 }} > {this.dictionary.pontaje.documenteHrInEvidenta}</h5>
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        {this.state.docs.map((a, idx) => {
                                            console.log('a :>> ', a);

                                            console.log('split :>> ', a.nume.split('.')[1].toLowerCase());

                                            return (

                                                <Grid style={{ marginBottom: 20, }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Grid onClick={() => { this.goToDoc(a) }} container>


                                                        <Grid style={{ textAlign: 'left', paddingTop: 10 }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                            <div style={{ display: 'inline-block' }}>
                                                                <img
                                                                    style={{
                                                                        width: 30,
                                                                        marginRight: 10,
                                                                        verticalAlign: 'bottom'
                                                                    }}
                                                                    src={
                                                                        a.nume.split('.')[1].toLowerCase() === 'jpg' ? picJpg : (a.nume.split('.')[1].toLowerCase() === 'pdf' ? picPdf : picWord)
                                                                    } />
                                                            </div>

                                                            <div style={{ display: 'inline-block' }}>
                                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, marginTop: 5 }}>{a.nume}</span>
                                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{ }</span>
                                                            </div>


                                                        </Grid>

                                                        <Grid style={{ paddingTop: 5 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                            <Grid container>

                                                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                    {
                                                                        this.props.angajat.poza &&
                                                                        <div
                                                                            className='pm-angajati-picture'

                                                                            style={{ backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                                        </div>
                                                                    }
                                                                    {!this.props.angajat.poza &&

                                                                        <Avatar
                                                                            className='pm-angajati-picture'
                                                                            style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(a.id), padding: 5, cursor: 'pointer' }}>
                                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                            <span style={{ display: 'block', marginTop: 6 }}>{this.numeAvatar(this.props.angajat.nume)} </span>
                                                                        </Avatar>
                                                                        // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                    }
                                                                </Grid>

                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                                    <span style={{ fontWeight: 500, fontSize: 14 }}>    {this.props.angajat.nume}</span><br />
                                                                    <span style={{
                                                                        fontSize: 12,
                                                                        color: '#9a9a9a'
                                                                    }}>{this.props.angajat.functie} - {this.props.angajat.nume_departament}</span>
                                                                </Grid>

                                                            </Grid>

                                                        </Grid>

                                                        <Grid style={{ textAlign: 'right', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 10 }}>
                                                                <img
                                                                    style={{
                                                                        width: 15,
                                                                        marginRight: 10,
                                                                        verticalAlign: 'bottom'
                                                                    }}
                                                                    src={
                                                                        a.nume.split('.')[1].toLowerCase() === 'jpg' ? picJpg : (a.nume.split('.')[1].toLowerCase() === 'pdf' ? picPdf : picWord)
                                                                    } />
                                                            </span>


                                                        </Grid>
                                                        <Grid style={{ textAlign: 'left', paddingTop: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(205 205 205)' }}>
                                                                {this.dictionary.pontaje.creatLa}
                                                            </span>
                                                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5, color: 'rgb(121	121	121	)' }}>
                                                                {this.u.ParseDataFromSql(a.cand_creat)}
                                                            </span>


                                                        </Grid>





                                                    </Grid>

                                                </Grid>
                                            )


                                        })}

                                    </Grid>

                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Divider style={{ marginTop: 20, marginBottom: 20 }} className='pm-divider' />
                                </Grid>


                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                    <input type='file' id={`document${this.props.angajat.id}`}
                                        style={{ display: 'none' }}
                                        accept='*'
                                        onChange={() => { this.uploadDocument(`document${this.props.angajat.id}`, this.props.angajat.id) }} />

                                    <Button
                                        style={{ width: '100%' }}

                                        className={'add-button-blue'} onClick={() => { this.selectFile(`document${this.props.angajat.id}`) }}  >
                                        <i style={{ marginLeft: 20 }} className='material-icons'>add</i>
                                        {this.dictionary.pontaje.documentNou}
                                    </Button>

                                </Grid>




                            </Grid>
                        </Grid>












                    </Grid>


                </Grid>
            </Grid >
        );
    }
}